import styles from './cell.module.scss'

import { Icon } from '..'

interface ICellProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
    children: React.ReactNode
}

export const Cell = ({ children, ...props }: ICellProps): React.ReactNode => {
    return (
        <button className={styles.cell} type='button' {...props}>
            {children}
            <div className={styles.cell__icon}>
                <Icon icon='chevron' size={24} />
            </div>
        </button>
    )
}
